var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultGalleryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.6849 6.2998H14.8516C12.5333 6.30749 10.3122 7.23184 8.67287 8.87111C7.03359 10.5104 6.10925 12.7315 6.10156 15.0498V40.8915L17.4182 29.5748C19.0857 27.9877 21.2996 27.1026 23.6016 27.1026C25.9036 27.1026 28.1174 27.9877 29.7849 29.5748L38.1586 37.9952L40.7486 35.4052C42.3933 33.772 44.6171 32.8553 46.9349 32.8553C49.2527 32.8553 51.4765 33.772 53.1211 35.4052L64.4349 46.7248V15.0498C64.4272 12.7315 63.5029 10.5104 61.8636 8.87111C60.2243 7.23184 58.0032 6.30749 55.6849 6.2998Z",
    fill: "#969D9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7849 29.5748C28.1174 27.9877 25.9036 27.1025 23.6016 27.1025C21.2996 27.1025 19.0857 27.9877 17.4182 29.5748L6.10156 40.8914V55.8831C6.10925 58.2014 7.03359 60.4225 8.67287 62.0618C10.3122 63.7011 12.5333 64.6254 14.8516 64.6331H55.6849C56.8615 64.6324 58.0258 64.3944 59.1083 63.9333C60.1908 63.4723 61.1691 62.7976 61.9849 61.9498L29.7849 29.5748Z",
    fill: "#969D9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M64.4345 46.7191L53.1207 35.4053C51.4761 33.7721 49.2523 32.8555 46.9345 32.8555C44.6166 32.8555 42.3928 33.7721 40.7482 35.4053L38.1582 37.9953L61.9728 61.9383C63.5536 60.3195 64.4374 58.1466 64.4345 55.8833V46.7191Z",
    fill: "#969D9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultGalleryIcon);
export default __webpack_public_path__ + "static/media/defaultGalleryIcon.7f559436f786233f9d3744aa1c2d68cf.svg";
export { ForwardRef as ReactComponent };